webpackJsonp([188095844526377],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/shop-merino-infinity-scarf.json":
/***/ (function(module, exports) {

	module.exports = {
		"pathContext": {
			"path": "/shop/merino-infinity-scarf/"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---shop-merino-infinity-scarf-2005adcfa53d1690f0d0.js